import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class BlockService {

    getEventRoute = '/api/subdivision/';

    constructor(private dataService: DataService) {
    };

    get( subdivisionId: number, refresh: boolean) {
        return this.dataService.getData('/api/subdivision/allblocklist/'+ subdivisionId, refresh);
    }

    getAll( subdivisionId: number, refresh: boolean) {
        return this.dataService.getData('/api/subdivision/allblockdetaillist/'+ subdivisionId, refresh);
    }

    getById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/subdivision/block/' + id, refresh);
    }

    updateBlock(result: any) {
        return this.dataService.post('/api/subdivision/update', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

}
